import React, {Fragment, useContext, useEffect, useRef, useState} from 'react';
import Modal from "react-bootstrap/Modal";
import {Col, Container, Dropdown, Form, Spinner, Image, ProgressBar, Button} from "react-bootstrap";
import { Context } from "../../../index";
import { observer } from "mobx-react-lite";
import Row from "react-bootstrap/Row";
import AvatarEditor from 'react-avatar-editor';
import defaultImage from "../../../assets/empty-cover.jpg";
import { Toast, ToastContainer } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {getRedirectUrlApi} from "../../../http/userAPI";


const CreateBook = observer(({ show, handleClose }) => {
    const { book } = useContext(Context);
    const { user } = useContext(Context);

    const [titleState, setTitleState] = useState('');
    const [subtitleState, setSubTitleState] = useState('');
    const [authorState, setAuthorState] = useState('');
    const [summaryState, setSummaryState] = useState('');
    const [originalCover, setOriginalCover] = useState(null); // Оригинальный файл
    const [coverFileState, setCoverFileState] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [coverPreview, setCoverPreview] = useState(defaultImage);
    const [amzlinkState, setAmzlinkState] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [showEditor, setShowEditor] = useState(false); // Управление отображением редактора
    const [scale, setScale] = useState(1);
    const [editorRef, setEditorRef] = useState(null);
    const [editorSize, setEditorSize] = useState({ width: 272, height: 410 });
    const [bookFormat, setBookFormat] = useState("6x9");

    const [paperbackAsinState, setPaperBackAsinState] = useState('');
    const [kindleAsinState, setKindleAsinState] = useState('');
    const [hardcoverAsinState, setHardCoverAsinState] = useState('');
    const [audioAsinState, setAudioAsinState] = useState('');
    const [audibleAsinState, setAudibleAsinState] = useState('');
    const [audioBookLinkState, setAudioBookLinkState] = useState('');

    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState("");

    const parentRef = useRef(null);

    const [newBook, setNewdBook] = useState({
        message_flag: false,
        paper_back_flag: false,
        kindle_flag: true,
        kindle_unlimited_flag: false,
        hard_cover_flag: false,
        audio_flag: false,
        audio_exclusive_flag: false,
        audio_non_exclusive_flag: false,
        cover_file: null,
        summary: null,
        book_file: null,
        bp_asin: null,
        k_asin: null,
        hc_asin: null,
        audio_asin: null,
        book_temp_file: null,

    });

    const [step, setStep] = useState(0); // Хранит текущий шаг
    const [nextStep, setNextStep] = useState({
        step0: true,
        step1: false,
        step2: false,
        step3: false,
        step4: false,
        step5: false,
        step6: false,
    });



    // 📌 Соотношения сторон для разных форматов книг
    const bookSizes = {
        "6x9": { aspectRatio: 6 / 9 },
        "8.5x11": { aspectRatio: 8.5 / 11 },
        "8.5x8.5": { aspectRatio: 8.5 / 8.5 },
        "8x10": { aspectRatio: 8 / 10 },
        "5x8": { aspectRatio: 5 / 8 },
        "7x10": { aspectRatio: 7 / 10 },
    };
    const [pdffile, setPdfFile] = useState(null)
    const [tempPDFFile, setTempPDFFile] = useState(''); // Для временного файла
    const [uploadProgress, setUploadProgress] = useState(0); // Для прогресса загрузки
    const [pdfFileTitle, setPdfFileTitle] = useState("")

    // 🔹 Функция обновления размеров (по `bookFormat` и при `resize`)
    useEffect(() => {
        const updateSize = () => {
            if (parentRef.current) {
                const parentWidth = parentRef.current.clientWidth;
                const selectedSize = bookSizes[bookFormat] || bookSizes["6x9"];
                const newHeight = parentWidth / selectedSize.aspectRatio;
                setEditorSize({ width: parentWidth, height: newHeight });
            }
        };

        updateSize();
        window.addEventListener("resize", updateSize);
        return () => window.removeEventListener("resize", updateSize);
    }, [bookFormat]); // Обновление при изменении формата книги

    useEffect(() => {
        const savedPdfFileTitle = localStorage.getItem("pdf_file_title");
        const savedTempPDFFile = localStorage.getItem("temp_pdf_file");

        if (savedPdfFileTitle) setPdfFileTitle(savedPdfFileTitle);
        if (savedTempPDFFile) setTempPDFFile(savedTempPDFFile);
    }, []);

    useEffect(() => {
        if (show) {
            loadBookDataFromLocalStorage();
        }
    }, [show]);





    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;

        setNewdBook((prevBook) => {
            let updatedBook = { ...prevBook, [name]: checked };

            // Если выбрали "Exclusive", отключаем "Non-Exclusive"
            if (name === "audio_exclusive_flag" && checked) {
                updatedBook.audio_non_exclusive_flag = false;
            }

            // Если выбрали "Non-Exclusive", отключаем "Exclusive"
            if (name === "audio_non_exclusive_flag" && checked) {
                updatedBook.audio_exclusive_flag = false;
            }

            return updatedBook;
        });
    };


    const isFormValid =
        user?.user?.id &&
        book?.selectedGenre?.id &&
        book?.selectedLanguage?.id &&
        titleState &&
        subtitleState &&
        authorState &&
        summaryState &&
        (newBook.paper_back_flag ||
            newBook.kindle_flag ||
            newBook.hard_cover_flag ||
            newBook.audio_flag ||
            newBook.kindle_unlimited_flag) &&
        (paperbackAsinState || kindleAsinState || hardcoverAsinState || audioAsinState) &&
        coverFileState && (tempPDFFile && pdfFileTitle)
         && (!newBook.audio_non_exclusive_flag || audioBookLinkState);



    const handleSubmitBookToModeration = () => {
        if (!isFormValid) {
            toast.warn("Fill all fields, please!", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }
        addBook();
    };



    const handleStepsChange = (step) => {
        let error = "";

        // 🔥 Проверяем, какие поля нужны для каждого шага
        if (step === 1 && (!titleState || !subtitleState || !authorState)) {
            error = "Please enter the Title, Subtitle and Author of Your Book!";
        } else if (step === 2 &&
            (!book.selectedLanguage.language || !book.selectedGenre.genre ||
                !(newBook.paper_back_flag || newBook.kindle_flag || newBook.hard_cover_flag || newBook.audio_flag))
        ) {  error = "Please select Language, Genre and at least one Type of Your Book!";
        }

        else if (step === 2 && newBook.audio_flag && !(newBook.audio_exclusive_flag || newBook.audio_non_exclusive_flag)) {
            error = "Please select the Contract Type for the Audio Book!";
        } else if (step === 4 && !coverFileState) {
            error = "Please Upload Cover of Your Book!";
        } else if (step === 5 && !summaryState) {
            error = "Please enter the Summary of Your Book!";
        } else if (step === 3 && !(paperbackAsinState || kindleAsinState || hardcoverAsinState || audioAsinState || audibleAsinState)) {
            error = "Please enter at least one ASIN!";
        } else if (step === 3 && newBook.audio_non_exclusive_flag && !audioBookLinkState) {
            error = "Please, enter a link to download your Audio Book!";
        }

        if (error) {
            setToastMessage(error); // Устанавливаем сообщение
            setShowToast(true); // Показываем тост
            return; // ❌ Прерываем смену шага
        }

        // ✅ Если все условия выполнены, передаем актуальные данные
        saveBookDataToLocalStorage({
            title: titleState,
            subtitle: subtitleState,
            author: authorState,
            language: book.selectedLanguage,
            genre: book.selectedGenre,
            audio_book_link: audioBookLinkState,

            summary: summaryState,
            pb_asin: paperbackAsinState,
            k_asin: kindleAsinState,
            hc_asin: hardcoverAsinState,
            audio_asin: audioAsinState,
            audible_asin: audibleAsinState,
            audible_link: audioBookLinkState,


            bookTypes: {
                paperBack: newBook.paper_back_flag,
                kindle: newBook.kindle_flag,
                kindle_u: newBook.kindle_unlimited_flag,
                hardCover: newBook.hard_cover_flag,
                audio: newBook.audio_flag,
                audio_ex: newBook.audio_exclusive_flag,
                audio_non_ex: newBook.audio_non_exclusive_flag,
            }
        });

        setNextStep((prev) => {
            const updatedSteps = Object.keys(prev).reduce((acc, key) => {
                acc[key] = false; // Сбрасываем все шаги в false
                return acc;
            }, {});

            return {
                ...updatedSteps,
                [`step${step}`]: true, // Включаем только текущий шаг
            };
        });

        setStep(step);
    };


// Функция сохранения данных анкеты в localStorage
    const saveBookDataToLocalStorage = (updatedFields = {}) => {
        const existingData = JSON.parse(localStorage.getItem("bookForm")) || {};

        const bookData = {
            ...existingData, // Берем старые данные
            ...updatedFields, // Обновляем только измененные поля
        };

           localStorage.setItem("bookForm", JSON.stringify(bookData));
    };


    const loadBookDataFromLocalStorage = () => {
        const savedData = localStorage.getItem("bookForm");
        if (savedData) {
            const bookData = JSON.parse(savedData);
            setTitleState(bookData.title || "");
            setSubTitleState(bookData.subtitle || "");
            setAuthorState(bookData.author || "");
            setSummaryState(bookData.summary || "");
            setPaperBackAsinState(bookData.pb_asin || "");
            setKindleAsinState(bookData.k_asin || "");
            setHardCoverAsinState(bookData.hc_asin || "");
            setAudioAsinState(bookData.audio_asin || "");
            setAudibleAsinState(bookData.audible_asin || "");
            setAudioBookLinkState(bookData.audible_link || "");

            setTempPDFFile(bookData.book_temp_file_name || "");

           setTempPDFFile(bookData.temp_pdf_file || "");
           setPdfFileTitle(bookData.pdf_file_title || "");


            // ✅ Загружаем обложку (если есть)
            if (bookData.cover_file) {
                const restoredBlob = base64ToBlob(bookData.cover_file);
                const restoredFile = new File([restoredBlob], bookData.cover_file_name, { type: "image/jpeg" });

                setCoverFileState(restoredFile); // Теперь `coverFileState` — это `File`
                setCoverPreview(bookData.cover_file);

            }


            // ✅ Загружаем язык и жанр
            book.setSelectedLanguage(bookData.language || {});
            book.setSelectedGenre(bookData.genre || {});

            setNewdBook((prev) => ({
                ...prev,
                paper_back_flag: bookData.bookTypes?.paperBack || false,
                kindle_flag: bookData.bookTypes?.kindle || false,
                hard_cover_flag: bookData.bookTypes?.hardCover || false,
                kindle_unlimited_flag: bookData.bookTypes?.kindle_u || false,
                audio_flag: bookData.bookTypes?.audio || false,
                audio_exclusive_flag: bookData.bookTypes?.audio_ex || false,
                audio_non_exclusive_flag: bookData.bookTypes?.audio_non_ex || false,
            }));
        }
    };


    const clearBookDataFromLocalStorage = () => {
        localStorage.removeItem("bookForm"); // Удаляем сохраненные данные книги
        handleClose();
    };


// ✅ Функция загрузки файла
    const selectBookFile = (e) => {
        const file = e.target.files[0];
        if (!file) {
            toast.error("Error: No file selected.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }

        // 🔹 Проверка формата и размера файла
        if (file.type !== "application/pdf") {
            toast.error(`Error: File "${file.name}" is not a PDF.`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }

        const maxFileSize = 500 * 1024 * 1024; // 500MB in bytes
        if (file.size > maxFileSize) {
            toast.error(`Error: File "${file.name}" exceeds 500MB limit.`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }

        // 🔹 Обновляем состояние файла
        setPdfFile(file);
        setPdfFileTitle(file.name); // Save the original file name

        // ✅ Save to `localStorage`
        saveBookDataToLocalStorage({
            pdf_file_title: file.name, // Save Base64 instead of an object
        });

        // 🔹 Создаем `FormData` и загружаем файл
        const formData = new FormData();
        formData.append("book_download_temp", file);

        try {
            const xhr = new XMLHttpRequest();
            xhr.open("POST", process.env.REACT_APP_API_URL + "api/book/temp", true);

            // 🔹 Обработчик прогресса
            xhr.upload.onprogress = (event) => {
                if (event.lengthComputable) {
                    const percentComplete = Math.round((event.loaded / event.total) * 100);
                    setUploadProgress(percentComplete >= 100 ? 99 : percentComplete);
                }
            };

            // 🔹 Обработчик завершения загрузки
            xhr.onload = () => {
                if (xhr.status === 200) {
                    toast.success("File uploaded successfully!", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });

                    const response = JSON.parse(xhr.responseText);
                    const tempFileName = response.tempPDFFile;

                    // 🔹 Save temporary file name
                    setTempPDFFile(tempFileName);

                    // ✅ Save to `localStorage`
                    saveBookDataToLocalStorage({
                        temp_pdf_file: tempFileName, // Save temporary file name
                    });

                    setUploadProgress(100);
                } else {
                    let errorMessage = `Upload failed: ${xhr.status}`;
                    try {
                        errorMessage = JSON.parse(xhr.responseText)?.message || errorMessage;
                    } catch (_) {}
                    toast.error(errorMessage, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                    setUploadProgress(-1);
                }
            };

            // 🔹 Обработчик ошибок
            xhr.onerror = () => {
                toast.error("Error uploading file.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                setUploadProgress(-1);
            };

            // 🔹 Отправляем файл на сервер
            xhr.send(formData);
        } catch (error) {
            toast.error(`Error sending file: ${error.message}`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        }
    };

// ✅ Функция для клика по скрытому input
    const triggerFileInputBook = () => {
        document.getElementById("fileInputBook").click();
    };




    const triggerFileInput = () => {
        document.getElementById("fileInput").click();
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file && file.type.startsWith("image/")) {
            setOriginalCover(file);
            const reader = new FileReader();
            reader.onload = (event) => {
                const imageBase64 = event.target.result;

                setCoverPreview(imageBase64);
                setShowEditor(true);

                // ✅ Сохраняем в `localStorage`
                saveBookDataToLocalStorage({
                    cover_file: imageBase64, // Сохраняем Base64 вместо объекта
                    cover_file_name: file.name,
                });


            };
            reader.readAsDataURL(file);
        }
    };

    const base64ToBlob = (base64) => {
        const byteCharacters = atob(base64.split(',')[1]); // Убираем `data:image/jpeg;base64,`
        const byteArrays = [];
        for (let i = 0; i < byteCharacters.length; i++) {
            byteArrays.push(byteCharacters.charCodeAt(i));
        }
        return new Blob([new Uint8Array(byteArrays)], { type: 'image/jpeg' });
    };


    const handleSave = () => {
        if (editorRef) {
            try {
                const canvas = editorRef.getImageScaledToCanvas();
                canvas.toBlob(
                    (blob) => {
                        if (blob) {
                            const reader = new FileReader();
                            reader.onload = (event) => {
                                const editedImageBase64 = event.target.result;

                                setCoverPreview(editedImageBase64);
                                setCoverFileState(blob);
                                setShowEditor(false);

                                // ✅ Обновляем данные в `localStorage`
                                saveBookDataToLocalStorage({
                                    cover_file: editedImageBase64,
                                    cover_file_prev: editedImageBase64,
                                });


                            };
                            reader.readAsDataURL(blob);
                        } else {

                        }
                    },
                    'image/jpeg',
                    0.9
                );
            } catch (error) {

            }
        } else {

        }
    };


    const handleEditOriginal = () => {
        let coverToEdit = originalCover;

        // ✅ Если `originalCover` отсутствует, загружаем из `localStorage`
        if (!coverToEdit) {
            const savedCover = localStorage.getItem("bookForm");
            if (savedCover) {
                const bookData = JSON.parse(savedCover);
                if (bookData.cover_file) {
                    coverToEdit = bookData.cover_file;

                }
            }
        }

        if (!coverToEdit) {

            return;
        }

        // ✅ Загружаем обложку в редактор
        setCoverPreview(coverToEdit);
        setShowEditor(true);
    };


    const resetModalFields = () => {
        // Очистка localStorage
        localStorage.removeItem("temp_pdf_file");

        // Сброс файла книги
        setTempPDFFile(null);
        setPdfFileTitle('');

        // Сброс данных книги
        setTitleState('');
        setSubTitleState('');
        setAuthorState('');
        setSummaryState('');
        setAmzlinkState('');

        // Сброс выбора языка и жанра
        book.setSelectedLanguage({});
        book.setSelectedGenre({});

        // Сброс флагов и обложки
        setCoverFileState(null);
        setCoverPreview(defaultImage);
        setOriginalCover(null);
        setShowEditor(false);
        setScale(1);

        // Очистка редактора
        setEditorRef(null);
    };




    const addBook = async () => {
        setLoading(true);
        setError('');

        try {
            const formData = new FormData();
            formData.append('userId', user.user.id);
            formData.append('booksGenreId', book.selectedGenre.id);
            formData.append('booksPriceId', 1);
            formData.append('booksLanguageId', book.selectedLanguage.id);
            formData.append('booksTypeId', 1);
            formData.append('title', titleState);
            formData.append('subtitle', subtitleState);
            formData.append('author', authorState);
            formData.append('book_type', 'book');
            formData.append('language', book.selectedLanguage.language);
            formData.append('amz_price', '');
            formData.append('summary', summaryState);
            formData.append('status', 'NEW');
            formData.append('message', '');
            formData.append('message_flag', false);
            formData.append('amz_link', '');
            formData.append('paper_back_flag', newBook.paper_back_flag);
            formData.append('kindle_flag', newBook.kindle_flag);
            formData.append('kindle_unlimited_flag', newBook.kindle_unlimited_flag);
            formData.append('audio_exclusive_flag', newBook.audio_exclusive_flag);
            formData.append('audio_non_exclusive_flag', newBook.audio_non_exclusive_flag);
            formData.append('hard_cover_flag', newBook.hard_cover_flag);
            formData.append('audio_flag', newBook.audio_flag);
            formData.append('default_price', 500);
            formData.append('default_decrement', 0);
            formData.append('total_words', '10000');
            formData.append('paper_back_asin', paperbackAsinState || '');
            formData.append('kindle_asin', kindleAsinState || '');
            formData.append('hard_cover_asin', hardcoverAsinState || '');
            formData.append('audio_asin', audioAsinState || '');
            formData.append('audio_audible_asin', audibleAsinState || '');
            formData.append('audio_download_link_ned', audioBookLinkState || '');

            // 🔹 Добавляем файл книги (если есть)
            if (tempPDFFile) {

                formData.append("book_download", tempPDFFile);
            } else {

            }

            // 🔹 Добавляем обложку (если есть)
            if (coverFileState) {

                formData.append('cover_file', coverFileState);
            } else {
                toast.warn("No cover image found!", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            }

            // 🔹 Отправляем книгу на сервер
            const xhr = new XMLHttpRequest();
            xhr.open("POST", process.env.REACT_APP_API_URL + "api/book/", true);

            // ✅ Обработчик успешной загрузки
            xhr.onload = () => {
                if (xhr.status === 200) {
                    const response = JSON.parse(xhr.responseText);
                    toast.success("Book created successfully!", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });

                    const newBookId = response.book.id;  // ✅ Сохраняем ID книги


                    clearBookDataFromLocalStorage();
                    handleClose(newBookId);  // ✅ Передаем `newBookId` в `handleClose`
                } else {

                    setError(`Server error: ${xhr.status}`);
                }
            };

            // ✅ Обработчик ошибок
            xhr.onerror = () => {
                toast.error("Error uploading book data.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                setError("An error occurred while uploading book data to the server.");
            };

            // 🔹 Отправляем `FormData`
            xhr.send(formData);

            // ✅ Очищаем поля формы
            resetModalFields();

        } catch (e) {
            toast.error(`❌ Error creating book: ${e.message}`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            const errorMessage = e.response?.data?.message || 'An error occurred while adding the book.';
            setError(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            show={show}
            onHide={() => { setError(''); handleClose(); }} // ✅ Закрытие окна без newBookId
            backdrop="static" // Окно не закроется при клике на фон
            keyboard={false}  // Окно не закроется при нажатии клавиши Esc
            className="modal-xl"
            id="staticBackdrop"
            tabindex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
        >


            <div className="modal-content" data-bs-backdrop="static">
                <div className="modal-header">
                    <h1 className="modal-title fs-5">Add a New Book to Virtalibry System:</h1>


                    <button
                        type="button"
                        className="btn-close"
                        onClick={() => {
                            setError('');
                            handleClose();
                        }}
                    ></button>
                </div>
                <Col className="m-lg-3">

                    <div className="modal-body">
                        {error && <div className="alert alert-danger">{error}</div>}
                        {nextStep.step0 ? (
                            <>
                                <Row className="mb-2 m-lg-2 mt-2 shadow bg-white rounded">

                            <h5 className="mx-auto m-2 p-2"><span className="badge text-bg-success">Step 1 </span> Enter Book
                                Title: </h5>

                            <Form className="mt-0 mb-3">
                                <Form.Control
                                    className="p-2 border border-secondary rounded"
                                    value={titleState}
                                    onChange={e => setTitleState(e.target.value)}
                                    placeholder="Please provide the complete Title of Your Book..."
                                    disabled={loading}
                                />
                            </Form>


                                </Row>
                        <Row className="mb-2 m-lg-2 mt-2 shadow bg-white rounded">

                            <h5 className="mx-auto p-2"><span
                                className="badge text-bg-success">Step 2 </span> Enter Book Subtitle: </h5>

                            <Form className="mt-0 mb-3">
                            <Form.Control
                                className="p-2 border border-secondary rounded"
                                    value={subtitleState}
                                    onChange={e => setSubTitleState(e.target.value)}
                                    placeholder="Please provide Subtitle of Your Book..."
                                    disabled={loading}
                                />
                            </Form>
                        </Row>


                        <Row className="mb-4 m-lg-2 mt-2 shadow bg-white rounded align-items-center">
                            <h5 className="mx-auto start-0 p-2">
                                <span className="badge text-bg-success">Step 3 </span> Enter Book Author:
                            </h5>

                            {/* Поле ввода на 2/3 ширины */}
                            <Col md={8}>
                                <Form className="mt-0 mb-3">
                                    <Form.Control
                                        className="p-2 border border-secondary rounded"
                                        value={authorState}
                                        onChange={e => setAuthorState(e.target.value)}
                                        placeholder="Enter Pen Name or Author Name of Your Book (Should Appear on Amazon)..."
                                        disabled={loading}
                                    />
                                </Form>
                            </Col>

                            {/* Кнопка справа, на 1/3 ширины */}
                            <Col md={4} className="d-flex justify-content-end">

                                <button
                                    type="button"
                                    className="btn btn-success mb-3 me-3 d-flex align-items-center"
                                    onClick={() => handleStepsChange(step + 1)}
                                    disabled={loading}
                                >
                                    Next <i className="ms-2 fas fa-arrow-circle-right"></i>
                                </button>

                            </Col>
                        </Row>
                    </>
                    ):('')}

                        {nextStep.step1 ? ( // ✅ Проверяем условие
                            <>
                                <Row w={100}

                                     className="mb-4 m-lg-2 mt-3 d-flex justify-content-center align-items-center shadow bg-white rounded">
                                    <Col md={10} className="start-0">

                                        <h5 className="mx-auto p-2"><span className="badge text-bg-success">Step 4 </span> Select Book Language, Genre, Type and Options: </h5>
                                        <p className="fw-normal lh-sm text-muted">
                                            Select the book's language and genre, as well as the formats in which it is available on Amazon or Audible. Depending on these parameters, different types of assignments will be available for this book, which you will be able to create.
                                        </p>
                                    </Col>
                                    <Col md={2} className="position-relative" style={{height: '80px'}}>

                                        <p className="  m-lg-4 d-inline-flex ">
                                            <button
                                                className="btn btn-outline-success position-absolute top-0 end-0"
                                                style={{marginRight: '20px'}}
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapseExample"
                                                aria-expanded={isOpen ? 'true' : 'false'}
                                                aria-controls="collapseExample"
                                                onClick={() => setIsOpen(!isOpen)}
                                            >
                                                Help?
                                            </button>
                                        </p>
                                    </Col>
                                    <div>

                                        <div className={`collapse ${isOpen ? 'show' : ''}`} id="collapseExample">
                                            <div className="card card-body mb-3">
                                                <div className="mt-0">
                                                    <b className="fw-bold mb-2" >Book Type:</b>
                                                    <ul className="text-muted fst-italic">
                                                        <li>Kindle - If your book is available in Kindle format, select the corresponding checkbox.</li>
                                                        <li>Kindle Unlimited - If your Kindle version is available under the Kindle Unlimited program, select the corresponding checkbox.</li>
                                                        <li>Paperback - If your book is available in paperback format, select the corresponding checkbox.</li>
                                                        <li>Hardcover - If your book is available in hardcover format, select the corresponding checkbox.</li>
                                                        <li>Audiobook - If your book is available in audio format, select the corresponding checkbox.</li>
                                                    </ul>
                                                    <p className="fw-normal lh-sm text-danger fst-italic">
                                                        Important: Amazon Audible offers two types of contracts for audiobooks—Exclusive and Non-Exclusive. Please specify which contract type applies to your book. Depending on the contract type, different assignment options for obtaining reviews will be available.
                                                    </p>
                                                  </div>
                                            </div>
                                        </div>
                                    </div>


                                    <Row className="h-100" >
                                        <Col xs={4} className="d-flex flex-column justify-content-start ">
                                            <div className="d-flex flex-column mb-0 align-items-start">
                                                <strong className="mb-1 mt-0 text-muted">Select Language of Book:</strong>
                                                <Dropdown className="mb-0">
                                                    <Dropdown.Toggle
                                                        variant="light"
                                                        style={{
                                                            width: '250px',
                                                            background: 'none',
                                                            border: '1px solid #ced4da',
                                                            color: '#495057',
                                                            textAlign: 'left'
                                                        }}
                                                    >
                                                        {book.selectedLanguage.language || "Select Language"}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu style={{ maxHeight: "300px", overflowY: "auto" }}>
                                                        {book.languages.map((lang) => (
                                                            <Dropdown.Item
                                                                onClick={() => book.setSelectedLanguage(lang)}
                                                                key={lang.id}
                                                                variant="success" // ✅ Bootstrap Success Variant для изменения цвета при наведении
                                                            >
                                                                {lang.language}
                                                            </Dropdown.Item>
                                                        ))}
                                                    </Dropdown.Menu>
                                                </Dropdown>

                                            </div>

                                            <div className="d-flex flex-column mb-0 align-items-start">
                                                <strong className="mb-1 mt-2 text-muted">Select Genre of Book:</strong>
                                                <Dropdown className="mb-5">
                                                    <Dropdown.Toggle
                                                        variant="light"
                                                        style={{
                                                            width: '250px',
                                                            background: 'none',
                                                            border: '1px solid #ced4da',
                                                            color: '#495057',
                                                            textAlign: 'left'
                                                        }}
                                                    >
                                                        {book.selectedGenre.genre || "Select Genre"}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu style={{ maxHeight: "300px", overflowY: "auto" }}>
                                                        {book.genres.map((gen) => (
                                                            <Dropdown.Item
                                                                onClick={() => book.setSelectedGenre(gen)}
                                                                key={gen.id}
                                                                variant="success" // ✅ Bootstrap Success Variant для изменения цвета
                                                            >
                                                                {gen.genre}
                                                            </Dropdown.Item>
                                                        ))}
                                                    </Dropdown.Menu>
                                                </Dropdown>



                                            </div>
                                        </Col>

                                        <Col mb={4} className="d-flex flex-column justify-content-start align-items-stretch">
                                            <strong className="text-muted">Select the Available Types for this Book:</strong>
                                            <Container className="shadow-lg bg-white rounded mt-1 mb-3 ">
                                                <Form.Check
                                                    className="mb-2 mt-2"
                                                    type="checkbox"
                                                    label="This Book is Available in Kindle Version?"
                                                    name="kindle_flag"
                                                    checked={newBook.kindle_flag}
                                                    onChange={handleCheckboxChange}
                                                />

                                                <Form.Check
                                                    type="checkbox"
                                                    className="mb-2 mt-2"
                                                    label="This Book is Available in Paperback?"
                                                    name="paper_back_flag"
                                                    checked={newBook.paper_back_flag}
                                                    onChange={handleCheckboxChange}
                                                />
                                                <Form.Check
                                                    className="mb-2 mt-2"
                                                    type="checkbox"
                                                    label="This Book is Available in Hardcover?"
                                                    name="hard_cover_flag"
                                                    checked={newBook.hard_cover_flag}
                                                    onChange={handleCheckboxChange}
                                                />

                                                <Form.Check
                                                    type="checkbox"
                                                    className="mb-2 mt-2"
                                                    label="This Book is Available in Audio Format?"
                                                    name="audio_flag"
                                                    checked={newBook.audio_flag}
                                                    onChange={handleCheckboxChange}
                                                />
                                            </Container>
                                        </Col>

                                        {/* ✅ Колонка с кнопкой прижатой вниз и вправо */}
                                        <Col xs={3}
                                             className="d-flex flex-column justify-content-start align-items-stretch">

                                                {newBook.kindle_flag ? (
                                                    <>
                                                        <div>
                                                        <strong className="m-2 text-muted">Kindle Unlimited Option?</strong>
                                                        <Container className="shadow-lg bg-white rounded mb-2 mt-1 p-2">
                                                            <Form.Check
                                                                type="checkbox"
                                                                className="mb-2 mt-2"
                                                                label="Yes, it's Kindle Unlimited!"
                                                                name="kindle_unlimited_flag"
                                                                checked={newBook.kindle_unlimited_flag}
                                                                onChange={handleCheckboxChange}
                                                            />
                                                        </Container>
                                                    </div>
                                                    </>
                                                ) : null}



                                                {newBook.audio_flag ? (
                                                    <>
                                                    <div>
                                                        <strong className="m-2 text-muted">Type of Audio Distribution?</strong>
                                                        <Container className="shadow-lg bg-white rounded mb-4 mt-1 p-2">
                                                            <Form.Check
                                                                type="checkbox"
                                                                className="mb-2 mt-2"
                                                                label="Exclusive Distribution"
                                                                name="audio_exclusive_flag"
                                                                checked={newBook.audio_exclusive_flag}
                                                                onChange={handleCheckboxChange}
                                                            />
                                                            <Form.Check
                                                                type="checkbox"
                                                                className="mb-2 mt-2"
                                                                label="Non-Exclusive Distribution"
                                                                name="audio_non_exclusive_flag"
                                                                checked={newBook.audio_non_exclusive_flag}
                                                                onChange={handleCheckboxChange}
                                                            />
                                                        </Container>
                                                    </div>
                                                    </>
                                                ) : null}


                                            {/* ✅ Прижимаем кнопку к правому нижнему углу */}
                                            <div className="mt-auto d-flex justify-content-end">

                                                <button
                                                    type="button"
                                                    className="btn btn-secondary mb-3 ms-auto"
                                                    onClick={() => handleStepsChange(step-1)}
                                                    disabled={loading}
                                                >
                                                 <i className="me-2 fas fa-arrow-circle-left"></i> Back
                                                </button>

                                                <button
                                                    type="button"
                                                    className="btn btn-success mb-3 ms-auto"
                                                    onClick={() => handleStepsChange(step+1)}
                                                    disabled={loading}
                                                >
                                                    Next <i className="ms-2 fas fa-arrow-circle-right"></i>
                                                </button>
                                            </div>
                                        </Col>
                                    </Row>


                                </Row>

                            </>
                        ) : null} {/* ✅ Если условие false, ничего не рендерим */}

                        <Row className="g-3 mt-0">
                              {nextStep.step2 && (
                                    <>
                                        <Col className="shadow bg-white rounded">



                                        <Row className="mb-3 m-auto mt-1 ">
                                            <h5 className="mx-auto p-3"><span
                                                className="badge text-bg-success">Step 5 </span> Insert the ASIN for the type you selected in step 4:</h5>

                                            {/* Проверяем, есть ли что-то в первой колонке */}
                                            {(newBook.paper_back_flag || newBook.kindle_flag) && (
                                                <Col md={6} style={{ maxWidth: "100%" }}>

                                                    {newBook.kindle_flag && (
                                                        <Form className="mt-0 mb-3">
                                                            <div className="small lh-3">Kindle ASIN:</div>
                                                            <div className="d-flex align-items-center">
                                                                <Form.Control
                                                                    className="p-2 border border-secondary rounded"
                                                                    value={kindleAsinState}
                                                                    onChange={e => setKindleAsinState(e.target.value)}
                                                                    placeholder="Enter Kindle ASIN..."
                                                                    disabled={loading}
                                                                />
                                                                <Button
                                                                    variant="info"
                                                                    className="ms-2 btn-sm"
                                                                    disabled={!kindleAsinState}
                                                                    onClick={async () => {
                                                                        try {
                                                                            const targetUrl = `${user?.user?.amz_country}/dp/${kindleAsinState}`;

                                                                            const response = await getRedirectUrlApi(targetUrl);

                                                                            if (response && response.redirectUrl) {
                                                                                window.open(response.redirectUrl, '_blank', 'noopener noreferrer');
                                                                            } else {
                                                                                console.error('Failed to get redirect URL');
                                                                            }
                                                                        } catch (err) {
                                                                            console.error('Redirect error:', err);
                                                                        }
                                                                    }}

                                                                >
                                                                    Check
                                                                </Button>
                                                            </div>
                                                        </Form>
                                                    )}

                                                    {newBook.paper_back_flag && (
                                                        <Form className="mt-0 mb-3">
                                                            <div className="small lh-3">Paperback ASIN:</div>
                                                            <div className="d-flex align-items-center">
                                                                <Form.Control
                                                                    className="p-2 border border-secondary rounded"
                                                                    value={paperbackAsinState}
                                                                    onChange={e => setPaperBackAsinState(e.target.value)}
                                                                    placeholder="Enter Paperback ASIN..."
                                                                    disabled={loading}
                                                                />
                                                                <Button
                                                                    variant="info"
                                                                    className="ms-2 btn-sm"
                                                                    disabled={!paperbackAsinState}
                                                                    onClick={async () => {
                                                                        try {
                                                                            const targetUrl = `${user?.user?.amz_country}/dp/${paperbackAsinState}`;

                                                                            const response = await getRedirectUrlApi(targetUrl);

                                                                            if (response && response.redirectUrl) {
                                                                                window.open(response.redirectUrl, '_blank', 'noopener noreferrer');
                                                                            } else {
                                                                                console.error('Failed to get redirect URL');
                                                                            }
                                                                        } catch (err) {
                                                                            console.error('Redirect error:', err);
                                                                        }
                                                                    }}
                                                                >
                                                                    Check
                                                                </Button>
                                                            </div>
                                                        </Form>
                                                    )}

                                                    {(newBook.audio_non_exclusive_flag || newBook.audio_exclusive_flag || newBook.audio_flag) && (
                                                        <>
                                                            {(newBook.audio_non_exclusive_flag || newBook.audio_exclusive_flag) && (
                                                                <Form className="mt-0 mb-3">
                                                                    <div className="small lh-3">Audible ASIN:</div>
                                                                    <div className="d-flex align-items-center">
                                                                        <Form.Control
                                                                            className="p-2 border border-secondary rounded"
                                                                            value={audibleAsinState}
                                                                            onChange={e => setAudibleAsinState(e.target.value)}
                                                                            placeholder="Enter Audible ASIN..."
                                                                            disabled={loading}
                                                                        />
                                                                        <Button
                                                                            variant="info"
                                                                            className="ms-2 btn-sm"
                                                                            disabled={!audibleAsinState}
                                                                            onClick={async () => {
                                                                                try {
                                                                                    const targetUrl = `${user?.user?.audible_country}/pd/${audibleAsinState}`;

                                                                                    const response = await getRedirectUrlApi(targetUrl);

                                                                                    if (response && response.redirectUrl) {
                                                                                        window.open(response.redirectUrl, '_blank', 'noopener noreferrer');
                                                                                    } else {
                                                                                        console.error('Failed to get redirect URL');
                                                                                    }
                                                                                } catch (err) {
                                                                                    console.error('Redirect error:', err);
                                                                                }
                                                                            }}
                                                                        >
                                                                            Check
                                                                        </Button>
                                                                    </div>
                                                                </Form>
                                                            )}
                                                        </>
                                                    )}
                                                </Col>
                                            )}

                                            {/* Если первая колонка есть → вторая md=6, иначе md="auto" */}
                                            <Col md={newBook.paper_back_flag || newBook.kindle_flag ? 6 : 8} style={{ maxWidth: "50%" }}>
                                                {newBook.hard_cover_flag && (
                                                    <Form className="mt-0 mb-3">
                                                        <div className="small lh-3">Hardcover ASIN:</div>
                                                        <div className="d-flex align-items-center">
                                                            <Form.Control
                                                                className="p-2 border border-secondary rounded"
                                                                value={hardcoverAsinState}
                                                                onChange={e => setHardCoverAsinState(e.target.value)}
                                                                placeholder="Enter Hardcover ASIN..."
                                                                disabled={loading}
                                                            />
                                                            <Button
                                                                variant="info"
                                                                className="ms-2 btn-sm"
                                                                disabled={!hardcoverAsinState}
                                                                onClick={async () => {
                                                                    try {
                                                                        const targetUrl = `${user?.user?.amz_country}/dp/${hardcoverAsinState}`;

                                                                        const response = await getRedirectUrlApi(targetUrl);

                                                                        if (response && response.redirectUrl) {
                                                                            window.open(response.redirectUrl, '_blank', 'noopener noreferrer');
                                                                        } else {
                                                                            console.error('Failed to get redirect URL');
                                                                        }
                                                                    } catch (err) {
                                                                        console.error('Redirect error:', err);
                                                                    }
                                                                }}
                                                            >
                                                                Check
                                                            </Button>
                                                        </div>
                                                    </Form>
                                                )}

                                                {newBook.audio_flag && (
                                                    <Form className="mt-0 mb-3">
                                                        <div className="small lh-3">Amazon Audio ASIN:</div>
                                                        <div className="d-flex align-items-center">
                                                            <Form.Control
                                                                className="p-2 border border-secondary rounded"
                                                                value={audioAsinState}
                                                                onChange={e => setAudioAsinState(e.target.value)}
                                                                placeholder="Enter Amazon Audio ASIN..."
                                                                disabled={loading}
                                                            />
                                                            <Button
                                                                variant="info"
                                                                className="ms-2 btn-sm"
                                                                disabled={!audioAsinState}
                                                                onClick={async () => {
                                                                    try {
                                                                        const targetUrl = `${user?.user?.amz_country}/dp/${audioAsinState}`;

                                                                        const response = await getRedirectUrlApi(targetUrl);

                                                                        if (response && response.redirectUrl) {
                                                                            window.open(response.redirectUrl, '_blank', 'noopener noreferrer');
                                                                        } else {
                                                                            console.error('Failed to get redirect URL');
                                                                        }
                                                                    } catch (err) {
                                                                        console.error('Redirect error:', err);
                                                                    }
                                                                }}
                                                            >
                                                                Check
                                                            </Button>
                                                        </div>
                                                    </Form>
                                                )}



                                            </Col>


                                             <Row>
                                                {newBook.audio_non_exclusive_flag && (
                                                    <Form className="mt-0 mb-3">
                                                        <div className="small lh-3">Enter Link to Your Non-Exclusive
                                                            Audio Book:
                                                        </div>
                                                        <div className="d-flex align-items-center">
                                                            <Form.Control
                                                                className="p-2 border border-secondary rounded"
                                                                value={audioBookLinkState}
                                                                onChange={e => setAudioBookLinkState(e.target.value)}
                                                                placeholder="Enter Link to Your Non-Exclusive Audio Book... https://drive.google.com/drive/"
                                                                disabled={loading}
                                                            />
                                                            <Button
                                                                variant="info"
                                                                className="ms-2 btn-sm"
                                                                disabled={!audioBookLinkState}
                                                                onClick={() => window.open(`${audioBookLinkState}`, '_blank',  'noopener noreferrer')}
                                                            >
                                                                Check
                                                            </Button>
                                                        </div>
                                                    </Form>
                                                )}
                                            </Row>
                                            </Row>

                                            <Row className="justify-content-end me-1 mb-2">

                                                <div className="mt-0 d-flex justify-content-end ms-4 gap-4">
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary mb-3"
                                                        onClick={() => handleStepsChange(step - 1)}
                                                        disabled={loading}
                                                    >
                                                        <i className="me-2 fas fa-arrow-circle-left"></i> Back
                                                    </button>

                                                    <button
                                                        type="button"
                                                        className="btn btn-success mb-3"
                                                        onClick={() => handleStepsChange(step + 1)}
                                                        disabled={loading}
                                                    >
                                                        Next <i className="ms-2 fas fa-arrow-circle-right"></i>
                                                    </button>
                                                </div>
                                            </Row>
                                        </Col>
                                    </>
                                )}

                        </Row>

<Row className="justify-content-center">
    <Col md={4} className="mt-1 ">
        {nextStep.step3 ? (
            <>
                <Row w={100} className="mb-2 m-lg-2 mt-2 shadow bg-white rounded">
                    <h5 className="mx-auto p-3"><span
                        className="badge text-bg-success">Step 6 </span> Upload Cover Image:
                    </h5>
                    {coverPreview && (
                        <div className="text-center mb-3 mt-0 ">
                            {showEditor ? (
                                <>
                                    <div ref={parentRef} style={{
                                        width: "90%",
                                        maxWidth: "500px",
                                        margin: "auto"
                                    }} className="mt-1">


                                        <AvatarEditor
                                            ref={(ref) => setEditorRef(ref)}
                                            image={coverPreview}
                                            width={editorSize.width}
                                            height={editorSize.height}
                                            border={0}
                                            scale={scale}
                                            borderRadius={0}
                                            className="text-center mb-0 mt-0 me-5 m-auto rounded"
                                        />
                                        <input
                                            type="range"
                                            min="1"
                                            max="2"
                                            step="0.005"
                                            value={scale}
                                            onChange={(e) => setScale(parseFloat(e.target.value))}
                                            className="form-range mt-2"
                                            style={{width: '100px'}}  // Устанавливаем ширину в 300px
                                        />
                                        <Row className="d-flex align-items-center justify-content-between mt-2">
                                            {/* Выбор формата книги */}
                                            <select
                                                value={bookFormat}
                                                onChange={(e) => setBookFormat(e.target.value)}
                                                className="form-select w-auto"
                                                style={{minWidth: "120px"}}  // Чтоб select не сжимался слишком сильно
                                            >
                                                <option value="6x9">Format: 6x9</option>
                                                <option value="8.5x11">Format: 8.5x11</option>
                                                <option value="8.5x8.5">Format: 8.5x8.5</option>
                                                <option value="8x10">Format: 8x10</option>

                                                <option value="5x8">Format: 5x8</option>
                                                <option value="7x10">Format: 7x10</option>
                                            </select>

                                            {/* Кнопка */}
                                            <button
                                                type="button"
                                                className="btn btn-success w-auto"
                                                onClick={handleSave}
                                            >
                                                Save Cover
                                            </button>
                                        </Row>
                                    </div>
                                </>
                            ) : (<img src={coverPreview}
                                      alt="Cover Preview"
                                      style={{objectFit: 'cover', borderRadius: '8px'}}
                                      width={300}
                                      className="img-fluid"/>
                            )}

                        </div>
                    )}
                </Row>

            </>
        ) : null} {/* ✅ Если условие false, ничего не рендерим */}

    </Col>
    {nextStep.step3 && (
        <>
    <Row w={100} className="mb-3 m-auto mt-2 justify-content-center ">
        <Col md={5} className="mt-1 shadow bg-white rounded">
        <div className="d-flex justify-content-center mb-3 mt-3">
            <button
                type="button"

                className="btn btn-primary btn-success flex-md-row me-2 "
                onClick={triggerFileInput}
                disabled={loading}
            >
                Upload Cover
            </button>
            <input
                type="file"
                id="fileInput"
                style={{display: "none"}}
                onChange={handleFileChange}
            />

            <button
                type="button"
                className="btn btn-secondary fflex-md-row me-5 "
                onClick={handleEditOriginal}
            >
                Edit
            </button>

            {/* ✅ Прижимаем кнопку к правому нижнему углу */}
            <button
                type="button"
                className="btn btn-secondary fflex-md-row me-2 "
                onClick={() => handleStepsChange(step-1)}
                disabled={loading}
            >
                <i className="me-2 fas fa-arrow-circle-left"></i> Back
            </button>
            <button
                type="button"
                className="btn btn-success fflex-md-row me-2 "
                onClick={() => handleStepsChange(step+1)}
                disabled={loading}
            >
                Next <i className="ms-2 fas fa-arrow-circle-right"></i>
            </button>
        </div>
        </Col>
    </Row>
</>
        )}
</Row>


                        <Row w={100}>
                            <Col md={12} className="mt-0">

                                {nextStep.step4 ? ( // ✅ Проверяем условие
                                    <>
                                        <Row w={100} className="mb-3 m-auto mt-1 shadow bg-white rounded">
                                            <h5 className="mx-auto p-3"><span
                                                className="badge text-bg-success">Step 7 </span> Briefly Describe Your
                                                Book:
                                            </h5>
                                            <Form className="mt-0 mb-3">
                                                <Form.Control
                                                    as="textarea"
                                                    rows={5}
                                                    value={summaryState}
                                                    onChange={e => setSummaryState(e.target.value)}
                                                    placeholder="Enter Book Summary..."
                                                    disabled={loading}
                                                />
                                            </Form>

                                            {(summaryState || newBook.hard_cover_flag) ? ( // ✅ Проверяем условие
                                                <>
                                                    <Row className="justify-content-end me-1 mb-2">

                                                        <div className="mt-3 d-flex justify-content-end ms-4 gap-4">
                                                            <button
                                                                type="button"
                                                                className="btn btn-secondary mb-3"
                                                                onClick={() => handleStepsChange(step - 1)}
                                                                disabled={loading}
                                                            >
                                                                <i className="me-2 fas fa-arrow-circle-left"></i> Back
                                                            </button>

                                                            <button
                                                                type="button"
                                                                className="btn btn-success mb-3"
                                                                onClick={() => handleStepsChange(step + 1)}
                                                                disabled={loading}
                                                            >
                                                                Next <i className="ms-2 fas fa-arrow-circle-right"></i>
                                                            </button>
                                                        </div>
                                                    </Row>

                                                </>
                                            ) : (
                                                <>
                                                    <div className="mt-auto d-flex justify-content-end">
                                                        <p className="mb-1 mt-0">After filling Summary, You Can go to the Next Step! </p>
                                                    </div>

                                                </>

                                            )}
                                        </Row>
                                    </>
                                ) : null} {/* ✅ Если условие false, ничего не рендерим */}




                            {nextStep.step5 ? (// ✅ Проверяем условие
                                <>
                                    <Row className="mb-3 m-auto mt-1 shadow bg-white rounded p-2">
                                        <h5 className="mx-auto p-3">
                                            <span className="badge text-bg-success">Step 8</span> Upload Book File (PDF up to 500 Mb):
                                        </h5>
                                        <p>
                                            If your file is larger than 500 Mb — no worries!
                                            You can easily reduce the file size without losing quality using the free service{" "}
                                            <a href="https://www.ilovepdf.com/compress_pdf" target="_blank" rel="noopener noreferrer">
                                                iLovePDF
                                            </a>.
                                            Just upload your PDF there, compress it, and download the smaller version.
                                            In most cases, the file size will be reduced several times!
                                        </p>

                                        {/* 🔹 Контейнер для кнопки и индикатора загрузки в одной строке */}
                                        <div className="d-flex align-items-center mt-2 justify-content-between w-100">
                                            {/* 🔴 Кнопка загрузки слева */}
                                            <Button variant="danger" onClick={triggerFileInputBook} className="me-3">
                                                Upload Book
                                            </Button>

                                            {/* 🔹 Индикатор загрузки справа */}
                                            {uploadProgress > 0 && (
                                                <div
                                                    className="progress flex-grow-1"
                                                    role="progressbar"
                                                    aria-valuenow={uploadProgress}
                                                    aria-valuemin="0"
                                                    aria-valuemax="90"
                                                    style={{ height: "38px" }} // Увеличенная высота
                                                >
                                                    <div
                                                        className={`progress-bar ${uploadProgress === 100 ? "bg-success" : "bg-info"}`}
                                                        style={{ width: `${uploadProgress}%` }}
                                                    >
                                                        {uploadProgress === 100
                                                            ? (
                                                                <span className="fs-6 fst-italic">
                                                                     Uploading {pdfFileTitle.length > 90
                                                                    ? pdfFileTitle.slice(0, 90) + '...'
                                                                    : pdfFileTitle
                                                                } is Complete!
    </span>
                                                            )
                                                            : uploadProgress === 99
                                                                ? <span className="fw-semibold fst-normal">Processing manuscript: watermarking and compressing...</span>
                                                                : `${uploadProgress}%`
                                                        }
                                                        </div>
                                                </div>
                                            )}
                                            {(pdfFileTitle && !uploadProgress) && (
                                                <>
                                                    <Col className="text-center shadow rounded py-2">
                                                        <strong className="text-muted fst-italic d-block">Already Uploaded: {pdfFileTitle}</strong>
                                                    </Col>
                                                </>
                                            )}


                                        </div>


                                        {/* 🔹 Скрытый input для загрузки */}
                                        <Form.Group className="mb-3">
                                            <Form.Control
                                                type="file"
                                                accept="application/pdf"
                                                id="fileInputBook"
                                                onChange={selectBookFile}
                                                style={{ display: "none" }}
                                            />
                                        </Form.Group>



                                            <div className="mt-2 d-flex justify-content-end ms-0 gap-0">
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary mb-3"
                                                    onClick={() => handleStepsChange(step - 1)}
                                                    disabled={loading}
                                                >
                                                    <i className="me-2 fas fa-arrow-circle-left"></i> Back
                                                </button>
                                            </div>


                                    {/* 🔹 Подсказка пользователю */}
                                        <div className="mt-auto d-flex justify-content-end">

                                            {(uploadProgress > 0 && uploadProgress < 100) ? (
                                            <p className="mb-1 text-muted">Processing manuscript: watermarking and compressing. Please wait...</p>
                                                ) : (uploadProgress !== 100 && !pdfFileTitle) ? (
                                            <p className="mb-1 text-muted">After Uploading Book File, You Can Send Book to Moderation!</p>
                                                ) : (
                                                <p className="mb-1 text-muted"><strong>Excellent!</strong> Now Click "Send Book to Moderation"!</p>
                                            )}
                                        </div>
                                    </Row>
                                </>
                            ) : null

                            } {/* ✅ Если условие false, ничего не рендерим */}



                        </Col>
                        </Row>

                    </div>
                </Col>
                <div className="modal-footer">

                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => {
                            setError('');
                            handleClose();
                        }}
                        disabled={loading}
                    >
                        Close
                    </button>
                    <button
                        type="button"
                        className={`btn ${isFormValid ? 'btn-success' : 'btn-light'}`}
                        onClick={handleSubmitBookToModeration}
                        disabled={!isFormValid || loading || (uploadProgress > 0 && uploadProgress < 100)}
                    >
                        {(loading || (uploadProgress > 0 && uploadProgress < 100))
                            ? <><Spinner as="span" animation="border" size="sm"/> {uploadProgress === 99 ? "Processing Manuscript" : "Uploading File"}</>
                            : 'Send Book to Moderation'}
                    </button>
                </div>
            </div>
            {/* Тост уведомление */}
            <ToastContainer position="middle-center" className="p-3">
                <Toast show={showToast} onClose={() => setShowToast(false)} delay={3000} autohide bg="danger">
                    <Toast.Body className="text-white">{toastMessage}</Toast.Body>
                </Toast>
            </ToastContainer>
        </Modal>

    );
});

export default CreateBook;
